export const guildIconUrl = (guild, size = 128) => {
  if (!guild) return null;
  const icon = guild.icon;
  if (!icon) return null;
  if (typeof icon === "string" && icon.startsWith("http")) return icon;
  return `https://cdn.discordapp.com/icons/${guild.id}/${icon}.png?size=${size}`;
};

export const userAvatarUrl = (user, size = 128) => {
  if (!user) return null;
  const avatar = user.avatar;
  if (!avatar) return null;
  if (typeof avatar === "string" && avatar.startsWith("http")) return avatar;
  const ext = String(avatar).startsWith("a_") ? "gif" : "png";
  return `https://cdn.discordapp.com/avatars/${user.id}/${avatar}.${ext}?size=${size}`;
};

export const inviteForGuild = (baseInvite, guildId) =>
  `${baseInvite}&guild_id=${guildId}&disable_guild_select=true`;
